import { IonButton, IonCheckbox, IonContent, IonHeader, IonIcon, IonItem, IonList, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { IonButtons } from '@ionic/react';
import { closeOutline, checkmarkOutline } from 'ionicons/icons';
import { EventTriggerSource } from '../../models/DeviceEvent';
import styles from '../DoorPolicyModal.module.css';
import { useState } from 'react';
import { useCommonTranslation, useModalTranslation } from '../../hooks/useTranslation';
import { getTriggerSourceLabel } from '../../utils/doorPolicyTranslations';

export interface EditDoorPolicyTriggerSourcePickerProps {
    triggerSources: EventTriggerSource[];
    onSelectTriggerSources: (sources: EventTriggerSource[]) => void;
    onClose: () => void;
}

const EditDoorPolicyTriggerSourcePicker = ({
    triggerSources,
    onSelectTriggerSources,
    onClose,
}: EditDoorPolicyTriggerSourcePickerProps) => {
    const [selectedSources, setSelectedSources] = useState(triggerSources);
    const { t: tCommon } = useCommonTranslation();
    const { t: tModals } = useModalTranslation();
    const triggerSourceOptions = Object.entries(EventTriggerSource)
        .filter((entry) => typeof entry[1] === 'number')
        .map(([label, value]) => ({
            label: getTriggerSourceLabel(tModals, value as EventTriggerSource),
            value: value as EventTriggerSource,
        }));
    const toggleSource = (value: EventTriggerSource) => {
        if (selectedSources.includes(value)) {
            setSelectedSources(selectedSources.filter((source) => source !== value));
        } else {
            setSelectedSources([...selectedSources, value]);
        }
    };

    return (
        <IonPage>
            <IonHeader translucent>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton
                            color="medium"
                            onClick={onClose}
                            aria-label={tCommon('buttons.cancel')}
                        >
                            <IonIcon slot="icon-only" icon={closeOutline} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle>{tModals('door_policy.pickers.trigger_source.title')}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton
                            color="primary"
                            aria-label={tCommon('buttons.save')}
                            onClick={() => {
                                onSelectTriggerSources(selectedSources);
                                onClose();
                            }}
                        >
                            <IonIcon slot="icon-only" icon={checkmarkOutline} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen color="light">
                <section className={`${styles.wrapper} ${styles.section}`}>
                    <h2 className={styles.sectionTitle}>{tModals('door_policy.pickers.trigger_source.heading')}</h2>
                    <IonList className={styles.listCard}>
                        {triggerSourceOptions.map((option) => {
                            const isSelected = selectedSources.includes(option.value);
                            return (
                                <IonItem
                                    key={option.value}
                                    button
                                    detail={false}
                                >
                                    <IonCheckbox
                                        checked={isSelected}
                                        onIonChange={(event) => {
                                            toggleSource(option.value);
                                        }}
                                    >{option.label}</IonCheckbox>
                                </IonItem>
                            );
                        })}
                    </IonList>
                </section>
            </IonContent>
        </IonPage>
    );
};

export const EditDoorPolicyTriggerSourcePickerView = (props: EditDoorPolicyTriggerSourcePickerProps) => (
    <EditDoorPolicyTriggerSourcePicker {...props} />
);

export default EditDoorPolicyTriggerSourcePicker;
